'use strict';

const Routing = require('./Routes.jsx');
module.exports.Page = {
  label: 'Page liée',
  picker_label: 'Chercher une page à lier',
  autocomplete_url: Routing.action('AutocompletePage')
};
module.exports.Admin = {
  label: 'Nom du commercial',
  picker_label: 'Chercher un commercial',
  autocomplete_url: Routing.action('AutocompleteAdmins')
};
module.exports.Etablishment = {
  label: 'Nom du myWO',
  picker_label: 'Chercher un myWO',
  autocomplete_url: Routing.action('AutocompleteEtablishments')
};
